import { render } from "./week13.vue?vue&type=template&id=2325867f"
import script from "./week13.vue?vue&type=script&lang=js"
export * from "./week13.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__